export default "__VITE_ASSET__8A9286uN__"